import labelGenericStyle from "./style.css"

export default function LabelGeneric({htmlFor,children,styledLabel}){
  return(
    <label htmlFor={htmlFor} className={`${styledLabel} ${labelGenericStyle}`}>{children}</label>
  )
}